(function () {
  const PARAM_KEY = 'key';
  const STORAGE_KEY = 'key';

  // -----------------------------
  // クエリパラメータ取得
  // -----------------------------
  function getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  // -----------------------------
  // 保存処理
  // -----------------------------
  function saveMemberNo() {
    const memberNo = getQueryParam(PARAM_KEY);
    if (memberNo) {
      localStorage.setItem(STORAGE_KEY, memberNo);
      console.log('member_no saved:', memberNo);
    }
  }

  // -----------------------------
  // カートページでhiddenへ反映
  // -----------------------------
  function injectMemberNoToCart() {
    const memberNo = localStorage.getItem(STORAGE_KEY);
    if (!memberNo) return;

    const cartForm = document.querySelector('form[action="/cart"]');
    if (!cartForm) return;

    let input = cartForm.querySelector('input[name="attributes[member_no]"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[member_no]';
      cartForm.appendChild(input);
    }

    input.value = memberNo;
    console.log('member_no injected to cart:', memberNo);
  }

  // -----------------------------
  // 初期実行
  // -----------------------------
  document.addEventListener('DOMContentLoaded', function () {
    saveMemberNo();
    injectMemberNoToCart();
  });
})();